import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-file-attach-spinner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-file-attach-spinner.component.html',
  styleUrls: ['./ops-file-attach-spinner.component.scss'],
})
export class OpsFileAttachSpinnerComponent {
  @Input() type: 'upload' | 'remove' = 'upload';
}
